import URI from 'urijs'
import moment from 'moment';
import { config } from '@/plugins/env.config'
import Vue from 'vue';

async function getBranches(companyId, attemptNumber = 1) {

    const getBranchesUri = new URI(config.apiBaseUrl)
    getBranchesUri.segment('rips')
    getBranchesUri.segment('v1')
    getBranchesUri.segment('catalogs')
    getBranchesUri.segment('branches')
    getBranchesUri.addSearch('company_id', companyId)


    const getTokenHeaders = {
        Authorization: `Bearer ${localStorage.getItem('accessToken')}`
    }

    try {
        return await Vue.prototype.$http.get(getBranchesUri.toString(), {
            headers: getTokenHeaders
        })
    } catch (error) {
        const maxAttempts = config.getTokenMaxAttempts
        const attemptDelayInSeconds = config.getTokenAttemptDelayInSeconds

        const response = error.response ? error.response : error
        const status = response.status ? response.status : error.status

        if (status === 500 && attemptNumber < maxAttempts) {
            await new Promise(resolve => setTimeout(resolve, attemptDelayInSeconds * 1000))
            return getBranches(companyId, attemptNumber + 1)
        }

        throw error
    }
}

async function getHealthcareProviders(companyId, attemptNumber = 1) {
    const getHealthcareProvidersUri = new URI(config.apiBaseUrl)
    getHealthcareProvidersUri.segment('rips')
    getHealthcareProvidersUri.segment('v1')
    getHealthcareProvidersUri.segment('catalogs')
    getHealthcareProvidersUri.segment('healthcare-providers')
    getHealthcareProvidersUri.addSearch('company_id', companyId)

    const getTokenHeaders = {
        Authorization: `Bearer ${localStorage.getItem('accessToken')}`
    }

    try {
        return await Vue.prototype.$http.get(getHealthcareProvidersUri.toString(), {
            headers: getTokenHeaders
        })
    } catch (error) {
        const maxAttempts = config.getTokenMaxAttempts
        const attemptDelayInSeconds = config.getTokenAttemptDelayInSeconds

        const response = error.response ? error.response : error
        const status = response.status ? response.status : error.status

        if (status === 500 && attemptNumber < maxAttempts) {
            await new Promise(resolve => setTimeout(resolve, attemptDelayInSeconds * 1000))
            return getHealthcareProviders(companyId, attemptNumber + 1)
        }

        throw error
    }
}

async function getRIPSHistory(companyId, payload, attemptNumber = 1) {
    const getRIPSHistoryUri = new URI(config.apiBaseUrl)
    getRIPSHistoryUri.segment('rips')
    getRIPSHistoryUri.segment('v1')
    getRIPSHistoryUri.segment('catalogs')
    getRIPSHistoryUri.segment('documents')
    getRIPSHistoryUri.segment('search')
    getRIPSHistoryUri.addSearch('page', payload.page)
    getRIPSHistoryUri.addSearch('size', payload.size)

    const body = {
        companyId,
        branchIdentifiers: payload.branchIdentifiers,
        processStatus: payload.status.map((item) => item.key),
        documentType: payload.invoiceType.map((item) => item.key)
    }

    if (payload.invoiceFinalDate) {
        body.endDate = payload.invoiceFinalDate ? `${moment(payload.invoiceFinalDate).format('YYYY-MM-DD')}T23:59:59Z` : null;
    }

    if (payload.invoiceInitialDate) {
        body.startDate = payload.invoiceInitialDate ? `${moment(payload.invoiceInitialDate).format('YYYY-MM-DD')}T00:00:00Z` : null;
    }

    if (payload.invoiceInitialDate && payload.invoiceFinalDate) {
        // Which date column the range filters on: GENERATION (default) or VALIDATION.
        body.dateFilterType = payload.dateFilterType || 'GENERATION';
    }

    if (payload.documentNumber) {
        body.documentNumber = parseInt(payload.documentNumber.replace(/[^0-9]/g, ''))
    }

    if (payload.payerType) {
        body.financierType = payload.payerType.key
    }

    if (payload.payer) {
        body.companyHealthcareProviderId = payload.payer.id
    }

    if (payload.naturalPersonDocumentId) {
        body.naturalPersonDocumentId = payload.naturalPersonDocumentId
    }

    if (payload.agreement.length > 0) {
        body.provider_agreements = payload.agreement.map((item) => item.id)
    }

    const getTokenHeaders = {
        Authorization: `Bearer ${localStorage.getItem('accessToken')}`
    }

    try {
        return await Vue.prototype.$http.post(getRIPSHistoryUri.toString(), body, {
            headers: getTokenHeaders
        })
    } catch (error) {
        const maxAttempts = config.getTokenMaxAttempts
        const attemptDelayInSeconds = config.getTokenAttemptDelayInSeconds

        const response = error.response ? error.response : error
        const status = response.status ? response.status : error.status

        if (status === 500 && attemptNumber < maxAttempts) {
            await new Promise(resolve => setTimeout(resolve, attemptDelayInSeconds * 1000))
            return getRIPSHistory(companyId, attemptNumber + 1)
        }

        throw error
    }
}

async function getRIPSHistoryDetail(id, attemptNumber = 1) {
    const getRIPSHistoryDetailUri = new URI(config.apiBaseUrl)
    getRIPSHistoryDetailUri.segment('rips')
    getRIPSHistoryDetailUri.segment('v1')
    getRIPSHistoryDetailUri.segment('documents')
    getRIPSHistoryDetailUri.segment(id)

    const getTokenHeaders = {
        Authorization: `Bearer ${localStorage.getItem('accessToken')}`
    }

    try {
        return await Vue.prototype.$http.get(getRIPSHistoryDetailUri.toString(), {
            headers: getTokenHeaders
        })
    } catch (error) {
        const maxAttempts = config.getTokenMaxAttempts
        const attemptDelayInSeconds = config.getTokenAttemptDelayInSeconds

        const response = error.response ? error.response : error
        const status = response.status ? response.status : error.status

        if (status === 500 && attemptNumber < maxAttempts) {
            await new Promise(resolve => setTimeout(resolve, attemptDelayInSeconds * 1000))
            return getRIPSHistoryDetail(id, attemptNumber + 1)
        }

        throw error
    }
}

async function getRIPSResultsById(id, attemptNumber = 1) {
    const getRIPSResultsByIdUri = new URI(config.apiBaseUrl)
    getRIPSResultsByIdUri.segment('rips')
    getRIPSResultsByIdUri.segment('v1')
    getRIPSResultsByIdUri.segment('results')
    getRIPSResultsByIdUri.segment(id)

    const getTokenHeaders = {
        Authorization: `Bearer ${localStorage.getItem('accessToken')}`
    }

    try {
        return await Vue.prototype.$http.get(getRIPSResultsByIdUri.toString(), {
            headers: getTokenHeaders
        })
    } catch (error) {
        const maxAttempts = config.getTokenMaxAttempts
        const attemptDelayInSeconds = config.getTokenAttemptDelayInSeconds

        const response = error.response ? error.response : error
        const status = response.status ? response.status : error.status

        if (status === 500 && attemptNumber < maxAttempts) {
            await new Promise(resolve => setTimeout(resolve, attemptDelayInSeconds * 1000))
            return getRIPSResultsById(id, attemptNumber + 1)
        }

        throw error
    }
}

async function postDownloadFiles(payload, attemptNumber = 1) {

    const postDownloadFilesUri = new URI(config.apiBaseUrl)
    postDownloadFilesUri.segment('rips')
    postDownloadFilesUri.segment('v1')
    postDownloadFilesUri.segment('files')
    postDownloadFilesUri.segment('download')

    const getTokenHeaders = {
        Authorization: `Bearer ${localStorage.getItem('accessToken')}`
    }

    try {
        return await Vue.prototype.$http.post(postDownloadFilesUri.toString(), payload, {
            headers: getTokenHeaders,
            responseType: 'blob'
        })
    } catch (error) {
        const maxAttempts = config.getTokenMaxAttempts
        const attemptDelayInSeconds = config.getTokenAttemptDelayInSeconds

        const response = error.response ? error.response : error
        const status = response.status ? response.status : error.status

        if (status === 500 && attemptNumber < maxAttempts) {
            await new Promise(resolve => setTimeout(resolve, attemptDelayInSeconds * 1000))
            return postDownloadFiles(payload, attemptNumber + 1)
        }

        error.response.data = await response.data.text().then(text => JSON.parse(text))

        throw error
    }
}

async function fetchCatalog(type) {
    const fetchCatalogUri = new URI(config.apiBaseUrl)
    fetchCatalogUri.segment('sync-catalogs')
    fetchCatalogUri.segment('v1')
    fetchCatalogUri.segment(type)

    const getTokenHeaders = {
        Authorization: `Bearer ${localStorage.getItem('accessToken')}`
    };

    try {
        const response = await Vue.prototype.$http.get(
            fetchCatalogUri.toString(),
            { headers: getTokenHeaders }
        );
        return { type, data: response.data, success: true };
    } catch (error) {
        console.error(`Error fetching catalog ${type}:`, error);
        return { type, data: null, success: false };
    }
}

async function getEmbedURL(user, attemptNumber = 1) {
    const getEmbedURL = new URI(config.apiBaseUrl)
    getEmbedURL.segment('rips')
    getEmbedURL.segment('v1')
    getEmbedURL.segment('dashboard')
    getEmbedURL.segment('embed-url')


    const getTokenHeaders = {
        Authorization: `Bearer ${localStorage.getItem('accessToken')}`
    };

    try {
        return await Vue.prototype.$http.get(
            getEmbedURL.toString(),
            { headers: getTokenHeaders, params: {user} }
        );
    } catch (error) {
        const maxAttempts = config.getTokenMaxAttempts
        const attemptDelayInSeconds = config.getTokenAttemptDelayInSeconds

        const response = error.response ? error.response : error
        const status = response.status ? response.status : error.status

        if (status === 500 && attemptNumber < maxAttempts) {
            await new Promise(resolve => setTimeout(resolve, attemptDelayInSeconds * 1000))
            return getEmbedURL(user, attemptNumber + 1)
        }

        throw error
    }
}



export {
    getBranches,
    getHealthcareProviders,
    getRIPSHistory,
    getRIPSHistoryDetail,
    getRIPSResultsById,
    postDownloadFiles,
    fetchCatalog,
    getEmbedURL
}